import generalConfig from '_/config/general';

export const QRCODE_SLOT_PREFIX = `${generalConfig.appScheme}slot/`;
export const QRCODE_LOCATION_PREFIX = `${generalConfig.appScheme}location/`;
export const QRCODE_SPACE_PREFIX = `${generalConfig.appScheme}space/`;
